(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    /**
   * Reveals the control past a threshold and keeps the progress ring in step.
   *
   * The scroll handler is throttled to one animation frame and marked passive,
   * so it never blocks scrolling. Class changes only happen when the visible
   * state actually flips, not on every frame.
   */
  class BackToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-back-to-top]');
      if (!this.button) return;

      this.showAfter = 500;
      this.visible = false;
      this.ticking = false;
      this.controller = new AbortController();

      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.measureCorner = this.measureCorner.bind(this);

      window.addEventListener('scroll', this.onScroll, {
        passive: true,
        signal: this.controller.signal,
      });
      window.addEventListener('resize', this.onScroll, {
        passive: true,
        signal: this.controller.signal,
      });
      window.addEventListener('resize', this.measureCorner, {
        passive: true,
        signal: this.controller.signal,
      });

      /**
       * Third-party badges attach to <body> well after this element connects,
       * so one measurement on load is not enough. Watching body's direct
       * children catches the insert; the timed passes catch anything that
       * animates into place after being inserted at zero height.
       */
      this.corner = new MutationObserver(this.measureCorner);
      this.corner.observe(document.body, { childList: true });
      [0, 1200, 3000].forEach((delay) => setTimeout(this.measureCorner, delay));

      this.button.addEventListener(
        'click',
        () => {
          /**
           * The href already scrolls the page. This moves focus to match, or a
           * keyboard user arrives at the top visually while their next Tab
           * carries on from the bottom of the document.
           */
          const skip = document.querySelector('.skip-link');
          if (skip) skip.focus({ preventScroll: true });
        },
        { signal: this.controller.signal }
      );

      this.update();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.corner) this.corner.disconnect();
    }

    /**
     * Publishes the height of anything pinned to the bottom-right corner, so
     * the button can sit above it instead of on top of it.
     *
     * Matched by position rather than by a list of vendor class names: a badge
     * only matters if it is actually in the way, and that is a geometric
     * question, not a question of who made it.
     */
    measureCorner() {
      const SELECTORS = [
        '.grecaptcha-badge',
        '.shopify-challenge__container',
        'iframe[src*="hcaptcha"]',
        'iframe[src*="recaptcha"]',
        'iframe[title*="captcha" i]',
      ];

      let clearance = 0;

      SELECTORS.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (el.closest('back-to-top')) return;

          const box = el.getBoundingClientRect();
          if (box.width < 8 || box.height < 8) return;

          const nearBottom = window.innerHeight - box.bottom < 140;
          const nearRight = window.innerWidth - box.right < 220;
          if (nearBottom && nearRight) {
            clearance = Math.max(clearance, box.height + 14);
          }
        });
      });

      this.style.setProperty('--to-top-clear', `${Math.round(clearance)}px`);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.update);
    }

    update() {
      this.ticking = false;

      const y = window.scrollY;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? Math.min(y / scrollable, 1) : 0;

      this.style.setProperty('--to-top-progress', progress.toFixed(3));

      const past = y > this.showAfter;
      if (past === this.visible) return;

      this.visible = past;
      this.classList.toggle('is-visible', past);
    }
  }

  if (!customElements.get('back-to-top')) {
    customElements.define('back-to-top', BackToTop);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /**
   * Intercepts every add-to-cart form on the page and shows the result.
   *
   * Delegated from the document rather than bound per form: product cards are
   * rendered by section markup that can be replaced wholesale by the theme
   * editor or by filtering, and a listener bound to a form that no longer
   * exists silently stops working.
   */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-drawer]');
      this.body = this.querySelector('[data-cart-drawer-body]');
      this.foot = this.querySelector('[data-cart-drawer-foot]');
      this.subtotal = this.querySelector('[data-cart-drawer-subtotal]');
      this.countEl = this.querySelector('[data-cart-drawer-count]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.controller = new AbortController();
      const signal = this.controller.signal;

      document.addEventListener('submit', (event) => this.onSubmit(event), { signal });

      this.querySelectorAll('[data-cart-drawer-close]').forEach((el) =>
        el.addEventListener('click', () => this.close(), { signal })
      );

      // The backdrop is outside the dialog's own box, so a click landing on
      // the element itself rather than its contents is a backdrop click.
      this.dialog.addEventListener(
        'click',
        (event) => {
          if (event.target === this.dialog) this.close();
        },
        { signal }
      );

      // Escape fires `cancel`; let the slide-out run instead of vanishing.
      this.dialog.addEventListener(
        'cancel',
        (event) => {
          event.preventDefault();
          this.close();
        },
        { signal }
      );

      this.body.addEventListener(
        'click',
        (event) => {
          const remove = event.target.closest('[data-cart-remove]');
          if (!remove) return;
          this.change(remove.dataset.cartRemove, 0);
        },
        { signal }
      );
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }

    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes('/cart/add')) return;

      event.preventDefault();

      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message);
          return this.refresh();
        })
        .then(() => {
          /**
           * Confirm on the button before the drawer arrives. The drawer is
           * the real feedback, but it is a whole page-shift away and it can
           * be dismissed instantly — the tick is what the shopper's eye is
           * still on, and it is what stops a second press on a slow line.
           */
          if (button) {
            button.classList.add('is-added');
            setTimeout(() => button.classList.remove('is-added'), 1600);
          }
          // Lets overlays that submitted the form (the quick view) step aside
          // before the drawer takes the top layer.
          document.dispatchEvent(new CustomEvent('cart:added', { detail: { form } }));
          this.open();
        })
        .catch((error) => {
          /**
           * A failed add is the one case where swallowing the error would be
           * worse than the page reload: the shopper needs to know the item did
           * not go in. Falling back to a real submit puts them on the cart
           * page with Shopify's own message.
           */
          console.error(error);
          form.submit();
        })
        .finally(() => {
          if (button) button.removeAttribute('aria-busy');
        });
    }

    change(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      })
        .then((response) => response.json())
        .then((cart) => this.render(cart))
        .catch((error) => console.error(error));
    }

    refresh() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => this.render(cart));
    }

    render(cart) {
      const money = (cents) =>
        (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: cart.currency,
        });

      if (this.countEl) {
        this.countEl.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
      }

      // Every count in the chrome, not just the header's — the drawer has no
      // way to know which surfaces are showing one.
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        const changed = el.textContent !== String(cart.item_count);
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;

        // Only when the number actually moved. Bumping on every render would
        // fire on a quantity change that left the count alone, which teaches
        // the shopper to ignore it.
        if (!changed || el.hidden) return;
        el.classList.remove('is-bumped');

        // Reading offsetWidth forces the class removal to land before it is
        // added back, or re-adding it in the same frame restarts nothing.
        void el.offsetWidth;
        el.classList.add('is-bumped');
      });

      if (!cart.items.length) {
        this.body.innerHTML = `<p class="cdraw__empty">${this.dataset.emptyText || ''}</p>`;
        this.foot.hidden = true;
        return;
      }

      this.body.innerHTML = cart.items
        .map((item) => {
          const image = item.image
            ? `<img class="cdraw__media" src="${item.image.replace(
                /(\.[a-z]+)(\?|$)/i,
                '_120x$1$2'
              )}" alt="" width="62" height="62" loading="lazy">`
            : '<span class="cdraw__media"></span>';

          // Variant title is "Default Title" on a single-variant product,
          // which is Shopify's internal name and means nothing to a shopper.
          const variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="cdraw__variant">${item.variant_title}</p>`
              : '';

          return `
            <div class="cdraw__line">
              ${image}
              <div>
                <p class="cdraw__name">${item.product_title}</p>
                ${variant}
                <div class="cdraw__meta">
                  <span>${item.quantity} &times; ${money(item.final_price)}</span>
                  <button class="cdraw__remove" type="button" data-cart-remove="${item.key}">
                    ${this.dataset.removeText || ''}
                  </button>
                </div>
              </div>
            </div>`;
        })
        .join('');

      if (this.subtotal) this.subtotal.textContent = money(cart.items_subtotal_price);
      this.foot.hidden = false;
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close() {
      this.dialog.classList.remove('is-open');

      const done = () => this.dialog.close();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return done();
      this.dialog.addEventListener('transitionend', done, { once: true });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Quick View buttons are handled by assets/quick-view.js, which also warms
     the request on hover. A second listener here opened the modal twice. */

  /* Quick Add trigger from product card hover buttons */
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-quick-add-trigger]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      e.stopPropagation();
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.querySelector('span').textContent = 'Adding…';

      const body = new FormData();
      body.append('id', addBtn.dataset.variantId);
      body.append('quantity', '1');

      fetch('/cart/add.js', { method: 'POST', body })
        .then(r => r.json())
        .then(() => {
          addBtn.querySelector('span').textContent = 'Added ✓';
          addBtn.removeAttribute('aria-busy');
          setTimeout(() => {
            addBtn.querySelector('span').textContent = 'Quick Add';
          }, 1500);
          /* Refresh cart count in header */
          fetch('/cart.js').then(r => r.json()).then(cart => {
            const counter = document.querySelector('[data-cart-count]');
            if (counter) {
              counter.textContent = cart.item_count;
              counter.hidden = cart.item_count === 0;
            }
          });
        })
        .catch(() => {
          addBtn.querySelector('span').textContent = 'Error';
          addBtn.removeAttribute('aria-busy');
          setTimeout(() => {
            addBtn.querySelector('span').textContent = 'Quick Add';
          }, 1500);
        });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
